import { doubleTabsModalActionTypes } from '@/components/modals/doubleTabsModal/Constants';

import type { Action } from '@/shared/types';

const initialState = {
	open: false,
};

export default function doubleTabsModalReducer(state = initialState, action: Action) {
	const { type, payload } = action;
	const { open } = payload || {};

	switch (type) {
		case doubleTabsModalActionTypes.TOGGLE_DOUBLE_TABS_MODAL:
			return {
				...state,
				open,
			};

		default:
			return state;
	}
}
